import { render, staticRenderFns } from "./bindtransactor.vue?vue&type=template&id=29acb8f0"
import script from "./bindtransactor.vue?vue&type=script&lang=js"
export * from "./bindtransactor.vue?vue&type=script&lang=js"
import style0 from "./bindtransactor.vue?vue&type=style&index=0&id=29acb8f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports